import { render, staticRenderFns } from "./shopMobActivity.vue?vue&type=template&id=2310b9ff&"
import script from "./shopMobActivity.vue?vue&type=script&lang=js&"
export * from "./shopMobActivity.vue?vue&type=script&lang=js&"
import style0 from "./shopMobActivity.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports